export const teamMailingProfileKeys = {
  all: ["autoleads", "team-mailing-profile"] as const,
  get: (teamId: number | null = null) =>
    [...teamMailingProfileKeys.all, "get", teamId] as const,
  exportSettings: (teamId: number) =>
    [...teamMailingProfileKeys.all, "export-settings", teamId] as const,
}
